import { Controller } from "@hotwired/stimulus";
import jsQR from "jsqr";

// Connects to data-controller="qr-scanner"
export default class extends Controller {
  static targets = ["video", "canvas", "startButton", "result", "qrData"];

  connect() {
    this.stream = null;
    this.scanning = false;
    this.startScanning();
  }

  disconnect() {
    this.stopScanning();
  }

  startScanning() {
    navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: "environment",
        width: { ideal: 1280 },
        height: { ideal: 720 }
      }
    })
      .then(stream => {
        this.stream = stream;
        this.videoTarget.srcObject = stream;

        // Wait for video to be ready
        this.videoTarget.onloadedmetadata = () => {
          this.videoTarget.play()
            .then(() => {
              this.videoTarget.classList.remove("hidden");
              this.canvasTarget.classList.add("hidden");
              this.startButtonTarget.classList.add("hidden");
              this.resultTarget.classList.add("hidden");

              this.scanning = true;
              this.scanQRCode();
            })
            .catch(error => {
              console.error("Error playing video:", error);
            });
        };
      })
      .catch(error => {
        console.error("Error accessing camera:", error);
        alert("Unable to access camera. Please ensure you have granted camera permissions.");
      });
  }

  stopScanning() {
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }
    this.scanning = false;
    this.videoTarget.classList.add("hidden");
    this.canvasTarget.classList.remove("hidden");
    this.startButtonTarget.classList.add("mb-4");
    this.startButtonTarget.classList.remove("hidden");
  }

  scanQRCode() {
    if (!this.scanning) return;

    if (this.videoTarget.readyState === this.videoTarget.HAVE_ENOUGH_DATA) {
      this.canvasTarget.height = this.videoTarget.videoHeight;
      this.canvasTarget.width = this.videoTarget.videoWidth;
      const context = this.canvasTarget.getContext("2d");
      context.drawImage(this.videoTarget, 0, 0, this.canvasTarget.width, this.canvasTarget.height);

      const imageData = context.getImageData(0, 0, this.canvasTarget.width, this.canvasTarget.height);
      const code = jsQR(imageData.data, imageData.width, imageData.height);

      if (code) {
        this.qrDataTarget.textContent = code.data;
        this.resultTarget.classList.remove("hidden");
        this.stopScanning();

        // Dispatch event with QR data
        const event = new CustomEvent("qrCodeScanned", { detail: { data: code.data } });
        document.dispatchEvent(event);
      } else {
        requestAnimationFrame(() => this.scanQRCode());
      }
    } else {
      requestAnimationFrame(() => this.scanQRCode());
    }
  }
}
